import React from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

const SceneArea = styled.div`
  box-sizing: border-box;
  position: relative;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  max-width: ${(props) => props.maxWidth};
  max-height: ${(props) => props.maxHeight};
  background-color: ${(props) => props.bgColor};
  background-image: url(${(props) => props.bgImg});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  padding: ${(props) => props.paddingSm};
  margin: auto;
  font-size: 16px;
  ${breakpoint('sm')`
    padding: ${(props) => props.padding};
  `}
`;

const ContentArea = styled.div`
  width: 100%;
  max-width: 1280px;
  height: 100%;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  ${breakpoint('md')`
    flex-direction: row;
  `}
`;

const Scene = ({
  color,
  bgColor,
  bgImg,
  width,
  maxWidth,
  height,
  maxHeight,
  padding,
  paddingSm,
  children,
  ...props
}) => {
  return (
    <SceneArea
      color={color}
      bgColor={bgColor}
      bgImg={bgImg}
      width={width}
      height={height}
      maxWidth={maxWidth}
      maxHeight={maxHeight}
      padding={padding}
      paddingSm={paddingSm}
      {...props}
    >
      <ContentArea>{children}</ContentArea>
    </SceneArea>
  );
};

Scene.propTypes = {
  color: propTypes.string,
  bgColor: propTypes.string,
  bgImg: propTypes.string,
  width: propTypes.string,
  maxWidth: propTypes.string,
  height: propTypes.string,
  maxHeight: propTypes.string,
  padding: propTypes.string,
  paddingSm: propTypes.string,
};

Scene.defaultProps = {
  color: 'white',
  bgColor: 'white',
  width: '100%',
  height: '100%',
  maxWidth: 'auto',
  maxHeight: 'auto',
  padding: '20px',
  paddingSm: '20px',
};

export default Scene;
